var icon = require('vue-svgicon')
icon.register({
  'ks-icon-user-clipboard': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M89.2 97.6H38.8v-5.88c0-8.4 16.8-13 25.2-13s25.2 4.62 25.2 13M64 47.2a12.6 12.6 0 1 1-12.6 12.6A12.6 12.6 0 0 1 64 47.2m0-16.8a4.2 4.2 0 1 1-4.2 4.2 4.2 4.2 0 0 1 4.2-4.2m29.4 0H75.84a12.54 12.54 0 0 0-23.68 0H34.6a8.4 8.4 0 0 0-8.4 8.4v58.8a8.4 8.4 0 0 0 8.4 8.4h58.8a8.4 8.4 0 0 0 8.4-8.4V38.8a8.4 8.4 0 0 0-8.4-8.4z"/>'
  }
})
